"use strict";

exports.__esModule = true;
exports.getGridOptions = void 0;
var _constants = require("../../constants");
var MAX_LAYOUT_COUNT = 3;
var getGridOptions = exports.getGridOptions = function getGridOptions(layout, showGridArray, showLegend, showTitle, uiModern) {
  if (uiModern === void 0) {
    uiModern = false;
  }
  var validatedShowGridArray = getSafeArray(showGridArray);
  switch (layout) {
    case _constants.LAYOUT_TWO_COLUMNS:
      return [{
        width: "42.5%",
        left: "5%",
        bottom: "15%",
        top: "15%",
        show: validatedShowGridArray[0]
      }, {
        width: "42.5%",
        right: "5%",
        bottom: "15%",
        top: "15%",
        show: validatedShowGridArray[1]
      }];
    case _constants.LAYOUT_TWO_ROWS:
      return [{
        height: "31.5%",
        left: "5%",
        top: "15%",
        right: "5%",
        show: validatedShowGridArray[0]
      }, {
        height: "31.5%",
        left: "5%",
        bottom: "15%",
        right: "5%",
        show: validatedShowGridArray[1]
      }];
    case _constants.LAYOUT_THREE_COLUMNS:
      return [{
        left: "5%",
        width: "25.55%",
        bottom: "15%",
        top: "15%",
        show: validatedShowGridArray[0]
      }, {
        left: "37.22%",
        width: "25.55%",
        bottom: "15%",
        top: "15%",
        show: validatedShowGridArray[1]
      }, {
        right: "5%",
        width: "25.55%",
        bottom: "15%",
        top: "15%",
        show: validatedShowGridArray[2]
      }];
    case _constants.LAYOUT_THREE_ROWS:
      return [{
        top: "15%",
        height: "18.89%",
        left: "5%",
        right: "5%",
        show: validatedShowGridArray[0]
      }, {
        top: "40.56%",
        height: "18.89%",
        left: "5%",
        right: "5%",
        show: validatedShowGridArray[1]
      }, {
        bottom: "15%",
        height: "18.89%",
        left: "5%",
        right: "5%",
        show: validatedShowGridArray[2]
      }];
    case _constants.LAYOUT_BOTTOM_ROW_TWO_TILES:
      return [{
        height: "31.5%",
        left: "5%",
        top: "15%",
        right: "5%",
        show: validatedShowGridArray[0]
      }, {
        width: "42.5%",
        height: "31.5%",
        left: "5%",
        bottom: "15%",
        show: validatedShowGridArray[1]
      }, {
        width: "42.5%",
        height: "31.5%",
        right: "5%",
        bottom: "15%",
        show: validatedShowGridArray[2]
      }];
    case _constants.LAYOUT_LEFT_COLUMN_TWO_TILES:
      return [{
        height: "31.5%",
        width: "42%",
        left: "5%",
        top: "15%",
        show: validatedShowGridArray[0]
      }, {
        height: "31.5%",
        width: "42%",
        left: "5%",
        bottom: "15%",
        show: validatedShowGridArray[1]
      }, {
        width: "42%",
        right: "5%",
        bottom: "15%",
        top: "15%",
        show: validatedShowGridArray[2]
      }];
    case _constants.LAYOUT_RIGHT_COLUMN_TWO_TILES:
      return [{
        width: "42%",
        left: "5%",
        bottom: "15%",
        top: "15%",
        show: validatedShowGridArray[0]
      }, {
        height: "31.5%",
        width: "42%",
        top: "15%",
        right: "5%",
        show: validatedShowGridArray[1]
      }, {
        height: "31.5%",
        width: "42%",
        bottom: "15%",
        right: "5%",
        show: validatedShowGridArray[2]
      }];
    case _constants.LAYOUT_TOP_ROW_TWO_TILES:
      return [{
        width: "42.5%",
        height: "31.5%",
        left: "5%",
        top: "15%",
        show: validatedShowGridArray[0]
      }, {
        width: "42.5%",
        height: "31.5%",
        right: "5%",
        top: "15%",
        show: validatedShowGridArray[1]
      }, {
        height: "31.5%",
        left: "5%",
        bottom: "15%",
        right: "5%",
        show: validatedShowGridArray[2]
      }];
    default:
      // Modern: the legend sits in the top-right corner, the title in the card header.
      var bottom = uiModern ? "26px" : showLegend ? "40px" : "20px";
      var top = uiModern && showLegend || showTitle ? "30px" : "10px";
      return [{
        top: top,
        bottom: bottom,
        left: "5%",
        right: "5%",
        show: validatedShowGridArray[0]
      }];
  }
};
var getSafeArray = function getSafeArray(array) {
  if (!Array.isArray(array)) {
    array = [];
  }
  if (array.length < MAX_LAYOUT_COUNT) {
    var tmpArray = [].concat(array);
    for (var i = tmpArray.length; i < MAX_LAYOUT_COUNT; i++) {
      tmpArray.push(true);
    }
    return tmpArray;
  }
  return array;
};